import React, { useRef, useState } from "react";
import { Alert, Badge, Button, Form } from "react-bootstrap";
import { maskPublicReviewName } from "./maskPublicReviewName";

export const fullReviewTextStyle = { whiteSpace: "pre-wrap", overflowWrap: "anywhere" };
export function studentReviewDate(value) {
  if (!value || !Number.isFinite(Date.parse(value))) return "—";
  return new Intl.DateTimeFormat("th-TH-u-ca-buddhist", { day: "numeric", month: "long", year: "numeric", timeZone: "Asia/Bangkok" }).format(new Date(value));
}
export function StudentReviewAuthor({ review, maskPublicName = false }) {
  const raw = typeof review.authorDisplayName === "string" ? review.authorDisplayName.trim() : "";
  const name = /\p{L}/u.test(raw) && !/[@\p{Cc}\p{Cf}]|[\d๐-๙]{6}/u.test(raw) ? raw : "";
  const [broken, setBroken] = useState(null);
  let avatar = null;
  // Only a backend-validated DTO may supply this field; never substitute
  // userDoc.photoURL or Auth photoURL directly in the client.
  try { const url = new URL(review.authorAvatarUrl); if (url.protocol === "https:" && !url.username && !url.password) avatar = url.href; } catch {}
  return <div className="d-flex gap-2 align-items-center">
    {avatar && broken !== avatar ? <img alt="" src={avatar} width="40" height="40" referrerPolicy="no-referrer" className="rounded-circle" style={{ objectFit: "cover" }} onError={() => setBroken(avatar)} />
      : <span className="rounded-circle bg-light border d-inline-flex align-items-center justify-content-center flex-shrink-0 text-dark" aria-hidden="true" style={{ width: 40, height: 40 }}>{Array.from(name).find((letter) => /\p{L}/u.test(letter)) || "U"}</span>}
    <span style={{ overflowWrap: "anywhere" }}>{maskPublicName ? maskPublicReviewName(raw) : name || "ผู้เรียนคอร์ส"}</span>
  </div>;
}
export function StudentReviewStatus({ status }) {
  return <Badge bg={status === "published" ? "success" : "secondary"}>{status === "published" ? "ส่งรีวิวแล้ว" : "ระงับเผยแพร่"}</Badge>;
}
export function ReviewReference({ reviewId }) {
  const input = useRef(null);
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const copy = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (!navigator.clipboard?.writeText) throw new Error("clipboard-unavailable");
      await navigator.clipboard.writeText(reviewId); setMessage("คัดลอกเลขอ้างอิงแล้ว");
    } catch { input.current?.focus(); input.current?.select(); setMessage("กรุณาคัดลอกเลขอ้างอิงจากช่องที่เลือกไว้"); }
    finally { setBusy(false); }
  };
  return <Form.Group controlId={`my-reference-${reviewId}`} className="mt-3">
    <Form.Label>เลขอ้างอิงการส่งรีวิว</Form.Label>
    <Form.Control ref={input} readOnly value={reviewId} onFocus={(event) => event.target.select()} />
    <Button size="sm" variant="outline-primary" className="mt-2" disabled={busy} onClick={copy}>คัดลอกเลขอ้างอิง</Button>
    {message && <div role="status" className="small mt-1">{message}</div>}
    <Form.Text className="d-block">ใช้ประกอบการตรวจสอบส่วนลดโดยผู้ดูแล เลขอ้างอิงเพียงอย่างเดียวไม่ยืนยันความเป็นเจ้าของบัญชี</Form.Text>
  </Form.Group>;
}
export function ReviewError({ message, retry, busy = false }) {
  return message ? <Alert variant="danger">{message}{retry && <Button className="ms-2" size="sm" disabled={busy} onClick={retry}>ลองอีกครั้ง</Button>}</Alert> : null;
}
